<div class="offerSlider mb-3 image-slider">
  <ngb-carousel class="image-slider__carousel">
    @for (exOf of externalOffers; track exOf.id) {
      <ng-template ngbSlide>
        <div class="picsum-img-wrapper image-slider__img-wrapper">
          @if (exOf?.image) {
            <img class="image image-slider__image"
                 [ngSrc]="exOf?.image.src"
                 [width]="imageService.width"
                 [height]="imageService.height"
                 [priority]="true"
                 alt="{{exOf.image.altText}}"
                 (click)="navigationService.navigateExtern(exOf.externalURL, true)">
          }
        </div>
        @if (showOfferData) {
          <div
            class="carousel-caption image-slider__caption"
            (click)="navigationService.navigateExtern(exOf?.externalURL, true)"
          >
            <p
              appSliderTextStyle
              class="image-slider__header"
              [innerHTML]="exOf?.header"
            ></p>
            <p
              appSliderTextStyle
              class="image-slider__description"
              [innerHTML]="exOf?.description"
            ></p>
          </div>
        }
      </ng-template>
    }
  </ngb-carousel>
</div>
